import React, {useRef, useEffect, useState} from 'react';

import _ from '../../utils/_';
import {on, off} from '../../utils/events';
import {post} from '../../services/artfinder-service';

import useModal from '../../hooks/use-modal/use-modal';
import constantsFactory from '../../utils/constants';
const {EVENTS} = constantsFactory();

import Loading from '../loading/loading';
import useTranslation from '../../hooks/use-translation/use-translation';
import Button from '../button/button';
import {H5} from '../typography/typography';

const ModalCreateCollection = () => {
  const target = useRef(null);
  const modal = useModal(target);
  const [loading, setLoading] = useState(false);
  const [error, setError]: any = useState(null);
  const [success, setSuccess]: any = useState(null);
  const {t} = useTranslation();

  const open = () => {
    setSuccess(null);
    setTimeout(modal.open, 0);
  };

  useEffect(() => {
    on(EVENTS.CLICK_CREATE_NEW_COLLECTION, open);

    return () => {
      off(EVENTS.CLICK_CREATE_NEW_COLLECTION, open);
      modal.destroy();
    };
  }, [modal]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return;
    }
    e.persist();
    setLoading(true);
    setError(null);
    setSuccess(null);
    post('/collections/api/', {
      name: e.target.name.value,
      description: e.target.description.value,
      action: e.target.action.value,
    })
        .then(() => {
          e.target.reset();
          setSuccess({message: t('Your new collection has been added')});
        })
        .catch((err) => {
          console.log(err);
          setError({message: t('Server error')});
        })
        .finally(() => {
          setLoading(false);
        });
  };

  return (
    <div
      ref={target}
      className="modal fade"
      tabIndex={-1}
      role="dialog"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <form onSubmit={handleSubmit}>
          <div className="modal-content">
            {loading && <Loading />}
            <div className="modal-header">
              <H5 style="art">{t('Create new collection')}</H5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error.message}
                </div>
              )}
              {success && (
                <div className="alert alert-success" role="alert">
                  {success.message}
                </div>
              )}

              <input type="hidden" name="action" value="new" />

              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name"
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control"
                  rows={3}
                  name="description"
                  placeholder="Description"
                ></textarea>
              </div>
            </div>
            <div className="modal-footer">
              <Button secondary dataDismiss="modal">
                Cancel
              </Button>

              <Button submit>Create</Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalCreateCollection;
